import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { RouterProvider } from 'react-router';
import './configuration/iframeResizerChild';

import { ErrorBoundary } from './components/ErrorBoundary';
import ErrorFallback from './components/ErrorFallback';
import { config } from './config';
import { getUserSessionHooks } from './configuration';
import { ensureUserIsLoggedIn } from './configuration/login';
import { store } from './configuration/setup/store';
import { router } from './routes/Router';

const App = () => (
    <ErrorBoundary fallback={<ErrorFallback />}>
        <RouterProvider router={router} />
    </ErrorBoundary>
);

const renderApplication = () => {
    createRoot(document.getElementById('root') as HTMLElement).render(
        <Provider store={store}>
            <App />
        </Provider>
    );
};

const isDev = import.meta.env.DEV;
const isProdPreview = import.meta.env.VITE_PRODUCTION_PREVIEW;
if ((isDev && config.enableMockServer) || isProdPreview) {
    try {
        await import('../mocks/browser').then(({ startWorker }) => startWorker());
    } catch (error) {
        // Keep the application booting even if the mock worker isn't available.
        // This can happen when `public/mockServiceWorker.js` is missing.
        console.warn('MSW failed to start, continuing without API mocking.', error);
    }
}

await ensureUserIsLoggedIn(renderApplication, getUserSessionHooks());
